import React from "react";
import "./portfolioselect3.css";
import { FaPlay } from "react-icons/fa";
import image1 from "../images/clean1.jpg";
import image2 from "../images/clean2.jpg";

const Portfoliodetail3 = () => {
  return (
    <div className="select-section">
      {/* Images Row */}
      <div className="select-images">
        <div className="image-box">
          <img src={image1} alt="Cleaning Service 1" />
        </div>

        <div className="image-box video-box">
          <img src={image2} alt="Cleaning Service 2" />
          <div className="play-button">
            <FaPlay />
          </div>
        </div>
      </div>

      {/* Text Section */}
      <div className="select-text">
        <h2>Making your home look its best</h2>
        <p>
          Pretium convallis lacinia. Quisque ac eros urna. Mauris eu molestie
          odio. Nullam id consectetur nibh, at luctus elit. Sed ipsum nunc,
          elementum vitae suscipit sit amet, malesuada in turpis. Vivamus vel
          augue congue, maximus tortor sed, malesuada urna. Nunc dictum diam
          eros. Nulla sit amet interdum tellus, a hendrerit dui. Lorem ipsum
          dolor sit amet, consectetur adipiscing elit.
        </p>
      </div>
    </div>
  );
};

export default Portfoliodetail3;
